export default __webpack_public_path__ + "static/media/irrigation-3.ade49702.jpg";